import { create } from 'zustand';
import { IExercise } from '../../../core/models/exercise';
import { Course } from '../models/Course.model';

interface CoursesState {
  course: null | Course;
  myCourses: any;
  courseShow: any;
  userMatriculatedCourse: any;
  showMatriculatedCourse: boolean;
  setMyCourses: any;
  loadedCourse: any;
  showAllCourses: boolean;
  setCourse: (course: Course) => void;
  setLoadedCourse: (loadedCourse: any) => void;
  isLoadingContent: boolean;
  setIsLoadingContent: (isLoadingContent: boolean) => void;
  setReview: (review: 'like' | 'dislike' | undefined) => void;
  setUserMatriculatedCourse: (userMatriculatedCourse: any) => void;
  setShowMatriculatedCourse: (showMatriculatedCourse: boolean) => void;
  setCourseShow: (userMatriculatedCourse: any) => void;
  setShowAllCourses: () => void;
  hideAllCourses: () => void;
  setCourseExercises: (courseExercises: IExercise[]) => void;
  resetCourses: () => void;
}

export const useCoursesStore = create<CoursesState>((set, get) => {
  return {
    course: null,
    courseShow: null,
    showAllCourses: false,
    userMatriculatedCourse: null,
    showMatriculatedCourse: true,
    isLoadingContent: false,
    loadedCourse: null,
    myCourses: null,
    setCourse: (course: Course) => set({ course }),
    setLoadedCourse: (loadedCourse: any) => set({ loadedCourse }),
    setReview: (review) => {
      const loadedCourse = get().loadedCourse;
      loadedCourse.selectedContentObject.review = review;
      set({ loadedCourse: loadedCourse });
    },
    setMyCourses: (myCourses: any) => {
      const sortedCourses =
        myCourses && myCourses.length
          ? (myCourses || [])
              .filter((it: { kind: string }) => it.kind === 'regular')
              .sort(
                (
                  a: { userStartedAt: string | number | Date },
                  b: { userStartedAt: string | number | Date }
                ) => {
                  const dateA = new Date(a.userStartedAt).getTime();
                  const dateB = new Date(b.userStartedAt).getTime();
                  return dateB - dateA;
                }
              )
          : null;

      const userMatriculatedCourse =
        sortedCourses && sortedCourses.length > 0 ? sortedCourses[0] : get().userMatriculatedCourse;

      set({
        myCourses,
        userMatriculatedCourse,
        showAllCourses: !userMatriculatedCourse,
        courseShow: userMatriculatedCourse,
        showMatriculatedCourse: !!userMatriculatedCourse,
      });
    },
    setShowAllCourses: () => {
      set({ showAllCourses: true });
    },
    hideAllCourses: () => {
      set({ showAllCourses: false });
    },
    setIsLoadingContent: (isLoadingContent: boolean) =>
      set({ isLoadingContent }),
    setUserMatriculatedCourse: (userMatriculatedCourse: any) =>
      set({ userMatriculatedCourse }),
    setShowMatriculatedCourse: (showMatriculatedCourse: boolean) =>
      set({ showMatriculatedCourse }),
    setCourseShow: (courseShow: any) => set({ courseShow }),
    setCourseExercises: (courseExercises) =>
      set((state) => {
        return {
          loadedCourse: {
            ...state.loadedCourse,
            selectedContentObject: {
              ...state.loadedCourse.selectedContentObject,
              targets: courseExercises,
            },
          },
        };
      }),
    resetCourses: () =>
      set({
        course: null,
        courseShow: null,
        showAllCourses: false,
        userMatriculatedCourse: null,
        showMatriculatedCourse: true,
        isLoadingContent: false,
        loadedCourse: null,
        myCourses: null,
      }),
  };
});
